import { LogLevel, PublicClientApplication } from '@azure/msal-browser';
import { AZURE_APPLICATION_ID } from '../../config_module';
import * as microsoftTeams from '@microsoft/teams-js';
import { isEmbbededInTeams } from '../../services/crossPlatform/crossPlatformService';

if (isEmbbededInTeams()) {
  microsoftTeams.initialize();
}

let globalMSALInstance = undefined;

const msalConfig = {
  auth: {
    clientId: AZURE_APPLICATION_ID,
    authority: 'https://login.microsoftonline.com/common',
    redirectUri: '/',
    postLogoutRedirectUri: '/',
    navigateToLoginRequestUrl: false
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
        }
      }
    }
  }
};

export const getMSALInstance = () => {
  if (globalMSALInstance === undefined) {
    globalMSALInstance = new PublicClientApplication(msalConfig);
  }
  return globalMSALInstance;
};

export const getAzureAccount = () => {
  const account = getMSALInstance().getAllAccounts()[0];
  if (account) {
    getMSALInstance().setActiveAccount(account);
  }
  return getMSALInstance().getAllAccounts()[0];
};

export const getTeamsToken = async () => {
  return new Promise((resolve, reject) => {
    return microsoftTeams.authentication.getAuthToken({
      successCallback: function(result) {
        resolve(result);
      },
      failureCallback: function(error) {
        reject(error);
      }
    });
  });
};

export const getLoginConfiguration = () => {
  return {
    scopes: ['User.Read']
  };
};

export const getTokenClaims = () => {
  return ['user.read'];
};
